/* CUSTOM quantity-clamp.js (Shopify-Session)
 *
 * Verhindert Tastatureingabe über max-Inventory hinaus.
 * Origin's HTML5-max-Attribut greift erst beim Submit — wir clampen schon
 * beim input/blur und zeigen einen Brand-Voice-Hinweis.
 */
(function () {
  function clampInput(input, showHint) {
    const max = parseInt(input.getAttribute('max'), 10);
    if (!max) return;
    const val = parseInt(input.value, 10);
    if (val > max) {
      input.value = max;
      if (showHint) showMaxHint(input, max);
    }
  }

  function showMaxHint(input, max) {
    const wrapper = input.closest('quantity-input') || input.parentElement;
    if (!wrapper) return;
    let hint = wrapper.querySelector('[data-qty-hint]');
    if (!hint) {
      hint = document.createElement('span');
      hint.setAttribute('data-qty-hint', '');
      hint.className = 'quantity__hint';
      hint.style.cssText = 'display:block;font-size:1.1rem;letter-spacing:0.08em;text-transform:uppercase;color:rgb(220,60,65);margin-top:0.6rem;opacity:0;transition:opacity .2s ease;';
      wrapper.insertAdjacentElement('afterend', hint);
    }
    hint.textContent = `Only ${max} available`;
    requestAnimationFrame(() => { hint.style.opacity = '1'; });
    clearTimeout(hint._timer);
    hint._timer = setTimeout(() => { hint.style.opacity = '0'; }, 2500);
  }

  function attach(input) {
    if (input._clampBound) return;
    input._clampBound = true;
    input.addEventListener('input', () => clampInput(input, true));
    input.addEventListener('blur', () => clampInput(input, false));
  }

  function scan(root) {
    (root || document).querySelectorAll('.quantity__input[max]').forEach(attach);
    // Sold-Out: Quantity-Wrapper komplett ausblenden
    (root || document).querySelectorAll('quantity-input.is-soldout').forEach(qi => {
      const wrap = qi.closest('.product-form__quantity, .product-form__input--quantity');
      if (wrap) wrap.classList.add('is-soldout-wrap');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => scan());
  } else {
    scan();
  }

  // Nach AJAX-Tausch durch glaze-picker neu scannen
  const observer = new MutationObserver((records) => {
    for (const r of records) {
      r.addedNodes.forEach(n => {
        if (n.nodeType !== 1) return;
        if (n.matches && n.matches('.quantity__input[max]')) attach(n);
        else if (n.querySelectorAll) scan(n);
      });
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
